import React from "react";
import { CLEAR_FILTERS } from "src/Utils";
import useResetFilters from "../useResetFilter";
import { Text } from "./styles";
var ResetFilter = function () {
    var _a = useResetFilters(), resetFilters = _a.resetFilters, resetIsActive = _a.resetIsActive;
    return (React.createElement(Text, { className: resetIsActive ? 'isActive' : '', onClick: resetFilters }, CLEAR_FILTERS));
};
export default ResetFilter;
